// extracted by mini-css-extract-plugin
export default {"label":"AgendaCustomLabel_label__KgInp"};